import React from 'react';
import { CheckButton } from '@apply/components';
import { isMobileScreen } from '@apply/ui';

interface UpdatedAgreementSignFieldProps {
    onChange: () => void;
    signedAgreement: boolean;
}

export const UpdatedAgreementSignField: React.FC<UpdatedAgreementSignFieldProps> = ({ onChange, signedAgreement = false }) => {
    const mobileScreen = isMobileScreen();
    return (
        <CheckButton
            id='eSignAgreement'
            selected={signedAgreement}
            onToggle={onChange}
            label='Consent to Use Electronic Records and Disclosures. By checking this check box
                    and clicking "SAVE", I acknowledge that I have read and agree on behalf of the
                    Business Entities to the Consent to Use Electronic Records and Disclosures.'
            width={mobileScreen ? '100%' : '480px'}
        />
    );
};
